import {
  createMedicalOrganization,
  deleteMedicalOrganization,
  updateMedicalOrganization
} from "../api/medicalOrganization";
import {
  createOrganizationVaccine,
  deleteOrganizationVaccine,
  updateOrganizationVaccine
} from "../api/organizationVaccine";
import {MedicalOrganizationVaccine} from "../../../types/MedicalOrganizationVaccine";
import {MEDICAL_ORGANIZATION_MODAL_CONTENT} from "../components/MedicalOrganizationModalContent";

type UseMedicalOrganizationMutationsProps = {
  formMode: "edit" | "add";
  editingMedicalOrganizationVaccine?: MedicalOrganizationVaccine;
  userToken: string;
  setDialogContent: (content: MEDICAL_ORGANIZATION_MODAL_CONTENT | "") => void;
  fetchMedicalOrganizationVaccines: () => Promise<void>;
};

export const useMedicalOrganizationMutations = ({
  formMode,
  editingMedicalOrganizationVaccine,
  userToken,
  setDialogContent,
  fetchMedicalOrganizationVaccines,
}: UseMedicalOrganizationMutationsProps) => {
  const onClickSaveEdit = async () => {
    if (!editingMedicalOrganizationVaccine) {
      return;
    }

    setDialogContent(MEDICAL_ORGANIZATION_MODAL_CONTENT.LOADING);
    if (formMode === "edit") {
      const {vaccines, ...tempMedicalOrganization} = editingMedicalOrganizationVaccine;

      await updateMedicalOrganization({
        medicalOrganization: {
          ...tempMedicalOrganization,
          latitude: parseFloat(String(tempMedicalOrganization.latitude)),
          longitude: parseFloat(String(tempMedicalOrganization.longitude)),
        },
        token: userToken
      });

      if (editingMedicalOrganizationVaccine.vaccineId) {
        await updateOrganizationVaccine({
          token: userToken,
          organizationVaccine: {
            id: editingMedicalOrganizationVaccine.vaccineId,
            vaccines: editingMedicalOrganizationVaccine.vaccines,
          }
        });
      } else {
        await createOrganizationVaccine({
          token: userToken,
          organizationVaccine: {
            id: "",
            medicalOrganizationId: editingMedicalOrganizationVaccine.id,
            vaccines: editingMedicalOrganizationVaccine.vaccines || [],
          }
        });
      }
    }

    if (formMode === "add") {
      const newOrganization = await createMedicalOrganization({
        medicalOrganization: {
          ...editingMedicalOrganizationVaccine,
          latitude: parseFloat(String(editingMedicalOrganizationVaccine.latitude)),
          longitude: parseFloat(String(editingMedicalOrganizationVaccine.longitude)),
        },
        token: userToken
      });

      if (newOrganization?.data?.id && editingMedicalOrganizationVaccine.vaccines.length > 0) {
        await createOrganizationVaccine({
          token: userToken,
          organizationVaccine: {
            id: "",
            medicalOrganizationId: editingMedicalOrganizationVaccine.id,
            vaccines: editingMedicalOrganizationVaccine.vaccines,
          }
        });
      }
    }

    setDialogContent("");
    await fetchMedicalOrganizationVaccines();
  };

  const onClickConfirmDelete = async () => {
    if (!editingMedicalOrganizationVaccine) {
      return;
    }

    setDialogContent(MEDICAL_ORGANIZATION_MODAL_CONTENT.LOADING);
    await deleteMedicalOrganization({token: userToken, id: editingMedicalOrganizationVaccine.id});
    await deleteOrganizationVaccine({token: userToken, id: editingMedicalOrganizationVaccine.vaccineId});
    setDialogContent("");
    await fetchMedicalOrganizationVaccines();
  };

  return {
    onClickSaveEdit,
    onClickConfirmDelete,
  };
};
